/**
 * ColumnHeader
 * Talkroute
 *
 * Created by Vel Genov on 07/22/21
 * Copyright (c) 2019 Talkroute. All right reserved.
 */

import React from "react";
import { useDispatch } from "react-redux";
import SyncIcon from '@material-ui/icons/Sync';
import { CircularProgress, IconButton } from "@material-ui/core";
import Tooltip from '@components/PresentationComponents/FormComponents/Tooltip';
import { useGetAllMeetingsQuery } from "@services/Moxtra.slice";
type Props = {
  text: string;
};

const ColumnHeader: React.FC<Props> = ({ text }) => {
  const {refetch: getAllMeetings, isFetching: isFetchingScheduledMeetings} = useGetAllMeetingsQuery();

  return <div style={{fontSize: 14}}>
    <div>
      {text || 'Meetings'} 
    </div>
    <div style={{position: "absolute", right: 10, top: 8}}>
      <Tooltip placement="right" title="Refresh">
        <IconButton disabled={isFetchingScheduledMeetings} onClick={getAllMeetings} style={{marginLeft: 8, width: 45, height: 45}}>
          {isFetchingScheduledMeetings ? <CircularProgress size={18} /> : <SyncIcon/>}
        </IconButton>
      </Tooltip>
    </div>
  </div>;
};

export default ColumnHeader;
